import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';

const DESTAQUES = ['Cardápio digital', 'Pedidos em tempo real', 'Financeiro simples'];

export function AuthSplitLayout({ titulo, subtitulo, children }: { titulo: string; subtitulo?: string; children: ReactNode }) {
  const location = useLocation();

  return (
    <div className="lizzi-auth-shell">
      <aside className="lizzi-auth-hero">
        <Link to="/" className="lizzi-auth-brand">
          <img src={logo} alt="Lizzi Food" width={32} height={32} />
          <strong>Lizzi Food</strong>
        </Link>

        <div className="lizzi-auth-hero-copy">
          <h2>Entre, cadastre e siga.</h2>
          <p>Visual limpo, acesso rápido e foco no que importa.</p>
        </div>

        <div className="lizzi-auth-feature-board lizzi-auth-feature-board-compact">
          {DESTAQUES.map((item) => (
            <span key={item} className="lizzi-auth-compact-pill">
              {item}
            </span>
          ))}
        </div>
      </aside>

      <main className="lizzi-auth-main">
        <div className="lizzi-painel-auth">
          <div className="lizzi-auth-mobile-brand">
            <img src={logo} alt="Lizzi Food" width={32} height={32} />
            <strong>Lizzi Food</strong>
          </div>

          <div className="lizzi-auth-panel-top">
            <div>
              <h1>{titulo}</h1>
              {subtitulo ? <p>{subtitulo}</p> : null}
            </div>

            <nav className="lizzi-auth-switcher" aria-label="Navegação de autenticação">
              <Link to="/login" className={location.pathname === '/login' ? 'ativo' : ''}>
                Entrar
              </Link>
              <Link to="/cadastro" className={location.pathname === '/cadastro' ? 'ativo' : ''}>
                Cadastro
              </Link>
            </nav>
          </div>

          <div className="lizzi-cartao-auth">{children}</div>
        </div>
      </main>
    </div>
  );
}
